import { render, staticRenderFns } from "./deal-store.vue?vue&type=template&id=69fd7cbc"
import script from "./deal-store.vue?vue&type=script&lang=js"
export * from "./deal-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports